import React, { memo } from "react";

import styled from "styled-components/macro";

import { focusVisibleCellStyles } from "./cellContainerStyles";

const BoolCell = memo(WrappedComponent);
export default BoolCell;

function WrappedComponent({
  columnID,
  entityID,
  entityType,
  value = "0",
  saveCellValue,
  canEdit,
  ...rest
}) {
  const isChecked = Number(value) > 0;

  const handleChange = () => {
    if (!canEdit) return;

    saveCellValue({
      columnID,
      entityID,
      entityType,
      value: { value: isChecked ? 0 : 1 },
      origValue: { value: isChecked ? 1 : 0 },
    });
  };

  const handleKeyPress = (e) => {
    if (e.key !== "Space") return;

    e.preventDefault();
    handleChange();
  };

  return (
    <Wrapper>
      <Clickable
        onClick={handleChange}
        className={!canEdit ? "disabled" : ""}
        role="checkbox"
        ariaChecked={isChecked}
        tabIndex={0}
        onKeyPress={handleKeyPress}
      >
        <IconHolder style={{ color: "#98A4A5" }}>
          <div className="fal fa-circle" />
        </IconHolder>
        <CheckboxHolder
          data-cy="checkboxCell"
          className={isChecked ? "on" : null}
          style={{ color: "#278dc1" }}
        >
          <div className="fas fa-check-circle" />
        </CheckboxHolder>
      </Clickable>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: relative;
  font-size: 24px;
`;

const Clickable = styled.div`
  ${focusVisibleCellStyles};
  cursor: pointer;
  width: 28px;
  height: 28px;
  margin: 0 auto;

  &.disabled {
    cursor: default;
    filter: grayscale(0.5);
  }
`;

const IconHolder = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;
const CheckboxHolder = styled(IconHolder)`
  opacity: 0;
  transform: translate(-50%, -50%) scale(0.5) rotate(45deg);
  visibility: hidden;
  transition: opacity 0.2s, transform 0.2s, visibility 0.2s;

  &.on {
    opacity: 1;
    transform: translate(-50%, -50%);
    visibility: visible;
  }
`;
